import React, { useState, useEffect } from "react";
import { TextInput, TextArea } from "../../Components/Inputs";
import init_supplier from "../init_supplier";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";

const EditSupplier = () => {
  const [input, setInput] = useState(init_supplier);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const request = useAxios();
  const { id } = useParams();

  useEffect(() => {
    getSupplierDetails();
  }, []);

  const getSupplierDetails = async () => {
    const res = await request({
      method: "GET",
      url: "suppliers/single-supplier",
      params: { id: parseInt(id) },
    });
    if (res === "error") return;

    const inputCpy = { ...init_supplier };
    inputCpy.name.value = res?.name || "";
    inputCpy.company.value = res?.company || "";
    inputCpy.email.value = res?.email || "";
    inputCpy.phone.value = res?.phone || "";
    inputCpy.address.value = res?.address || "";

    setInput(inputCpy);
  };

  const handleSubmit = async (data) => {
    setIsLoading(true);
    const payload = {
      name: data.name.value,
      company: data.company.value || null,
      email: data.email.value || null,
      phone: data.phone.value || null,
      address: data.address.value || null,
    };

    const res = await request({
      method: "PUT",
      url: `suppliers/update/${id}`,
      body: payload,
      show_loading: true,
      loadingFunc: setIsLoading,
    });

    setIsLoading(false);
    if (res === "error") return;

    navigate("/dashboard/suppliers");
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-2xl font-bold text-gray-700 mb-6">
        Edit Supplier
      </h3>

      <TextInput
        input={input}
        setInput={setInput}
        field="name"
        validate={validate}
      />
      <TextInput
        input={input}
        setInput={setInput}
        field="company"
        validate={validate}
      />
      <TextInput
        input={input}
        setInput={setInput}
        field="email"
        validate={validate}
      />
      <TextInput
        input={input}
        setInput={setInput}
        field="phone"
        validate={validate}
      />
      <TextInput
        input={input}
        setInput={setInput}
        field="address"
        validate={validate}
      />

      <div className="mt-6 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/suppliers")}>Back</Btn>
        <Btn onClick={handleValidation} disabled={isLoading}>
          {isLoading ? "Updating..." : "Submit"}
        </Btn>
      </div>
    </div>
  );
};

export default EditSupplier;
